import * as React from "react";
import { useContext } from "react";
import { PluginStore } from "graylog-web-plugin/plugin";
import OnVisualizationConfigChangeContext from "views/components/aggregationwizard/OnVisualizationConfigChangeContext";
import EmptyAggregationContent from "./EmptyAggregationContent";
const defaultVisualizationType = "table";
export const retrieveChartData = (data) => {
  var _a;
  return (_a = data.chart) != null ? _a : data[Object.keys(data).filter((name) => name !== "events")[0]];
};
export const makeVisualization = (component, type) => Object.assign(component, { type });
const _visualizationForType = (type) => {
  const visualizationTypes = PluginStore.exports("visualizationTypes");
  const visualization = visualizationTypes.filter((viz) => viz.type === type)[0];
  if (!visualization) {
    throw new Error(`Unable to find visualization component for type: ${type}`);
  }
  return visualization.component;
};
const getResult = (value) => {
  if (value.type === "events") {
    return value.events;
  }
  return value.rows;
};
const AggregationBuilder = ({
  config,
  data,
  editing = false,
  fields,
  toggleEdit,
  setLoadingState,
  height,
  width
}) => {
  const onVisualizationConfigChange = useContext(OnVisualizationConfigChangeContext);
  if (!config || config.isEmpty) {
    return /* @__PURE__ */ React.createElement(EmptyAggregationContent, { toggleEdit, editing });
  }
  const VisComponent = _visualizationForType(config.visualization || defaultVisualizationType);
  const { effective_timerange: effectiveTimerange } = data.chart || Object.values(data)[0] || {};
  const rows = Object.fromEntries(
    Object.entries(data).map((tuple) => tuple).map(([key, value]) => [key, getResult(value)])
  );
  return /* @__PURE__ */ React.createElement(
    VisComponent,
    {
      config,
      data: rows,
      setLoadingState,
      effectiveTimerange,
      editing,
      fields,
      height,
      width,
      toggleEdit,
      onChange: onVisualizationConfigChange
    }
  );
};
export default AggregationBuilder;
